// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"143c0215","453":"dba4ed31","455":"bcd5ce42","977":"14b120a6"}[chunkId] + ".chunk.js";
};